import { AppointmentStatusEnum } from '@models/appointment'

import dayjs from '@/libs/dayjs'

export class BootstrapUtil {
  public static AppointmentStatusSuffixClassName(appointmentStatus?: AppointmentStatusEnum) {
    return appointmentStatus
      ? {
          [AppointmentStatusEnum.CANCELED]: 'danger',
          [AppointmentStatusEnum.CHECKED_IN]: 'green',
          [AppointmentStatusEnum.SCHEDULED]: 'green',
          [AppointmentStatusEnum.PENDING]: 'warning',
        }[appointmentStatus]
      : ''
  }
}

export const addDateToTimeFn = (date: string, time: string) => {
  const TimeDayJs = dayjs(time, 'HH:mm')
  return dayjs(date, 'YYYY-MM-DD')
    .set('hour', TimeDayJs.get('hour'))
    .set('minute', TimeDayJs.get('minute'))
    .toTzISOString()
}
